var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"marketing-page"},[_c('PortalHeader'),_c('main',{staticClass:"marketing-main"},[_c('section',{staticClass:"page-hero"},[_c('div',{staticClass:"container hero-inner"},[_vm._t("hero")],2)]),_c('section',{staticClass:"page-body"},[_c('div',{staticClass:"container body-inner"},[_vm._t("default")],2)])]),_c('PortalFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }